//
// FeatureFlag.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/TransportModel";
import "./FeatureFlagInfo";

var FeatureFlag = createModule("transport::FeatureFlag", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        id: 7,
        version: 4,
        enabled: 2,
        info: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default FeatureFlag;
